export const EVENT_CARD_IMAGE_TRANSFORM = 'w=327&h=250&fit=crop&crop=smart&f=webp&q=90&c=1&f2=jpg';
export const PRODUCT_CARD_IMAGE_TRANSFORM = 'w=329&h=300&fit=crop&crop=smart&f=webp&q=90&c=1&f2=jpg';
export const RENT_CARD_IMAGE_TRANSFORM = 'w=353&h=280&fit=crop&crop=center&f=webp&q=90&c=1&f2=jpg';
export const LOGO = 'w=40&h=40&crop&fit=cover&f=webp';
export const CARD_LOGO = 'w=80&h=80&crop&fit=cover&f=webp';
export const EASY_TABLE_IMAGE_TRANSFORM = 'w=60&h=60&fit=crop&crop=smart&f=webp&q=90&c=1&f2=jpg';